import React, { useEffect, useState, useCallback } from "react";
import ViewPreDefinedIndex from "../../../../components/View/ViewPreDefinedIndex";
import { useStandard } from "../../../../context/StandardContext";
import useGetStandardDetail from "../../../../hooks/useGetStandardDetail";
import { useLocation, useParams } from "react-router-dom";
import useFetchPreReport from "../../../../hooks/useFetchPreReport";
import NuDateFormat from "../../../../utils/NuDate";
import { CloseIcon } from "../../../../assets/icons";
import { useFormik } from "formik";
import { handleKeyDown } from "../../../../utils/OtherFunctions";
import { NuDate } from "../../../../utils/Inputs";
import FormikSelectTwo from "../../../../utils/Select";
import { CancelButton, SubmitButton } from "../../../../utils/Button";
import useGetStatusData from "../../../../hooks/useGetStatusData";
import DecryptData from "../../../../utils/Decrypt";
import useGetCompanyInfo from "../../../../hooks/useGetCompanyInfo";
import PDFGenerationScreen from "../../PDFGenerationScreen";
import FilterModal from "./FilterModal"; // Extracted filter modal component
import { memo } from 'react';
import { Image } from '@react-pdf/renderer';
import Logo from "../../../../assets/images/logo.jpg";

const MODULE_ID = 11; // Move to constants

function VendorManagementReport() {
  const { standardName } = useStandard();
  const { stdId } = useParams();
  const location = useLocation();
  const { statusValue } = useGetStatusData({ value: MODULE_ID });
  const { standardDetailName, standardStartDate, standardEndDate } = useGetStandardDetail({ id: stdId });

  const { company } = useGetCompanyInfo();
  const userData = localStorage.getItem("aTaDrEsU") ? DecryptData("aTaDrEsU") : {};
 
console.log("ssssszzzzz",location.state?.reportValue);

  // State
  const [filterParams, setFilterParams] = useState({
    standard_id: stdId,
    module_id: MODULE_ID,
    type: location.state?.reportValue?.reset_count ||0,
    status_name: "",
    from_date:  "",
    to_date: "",
  });
  const [pdfUrl, setPdfUrl] = useState(null);
  const [isDataLoading, setIsDataLoading] = useState(true);
  const [showFilter, setShowFilter] = useState(false);

  const { data, isLoading, review } = useFetchPreReport({
    url: `/report/`,
    value: filterParams,
  });

  // PDF Generation
  useEffect(() => {
    const worker = new Worker(new URL('./vmPDFWorker.jsx', import.meta.url));

    worker.onmessage = (e) => {
      setPdfUrl(e.data);
      setIsDataLoading(false);
    };

    if (data.length > 0) {
      worker.postMessage({
        data,
        company:company,
        standardDetailName,
        review,
        standardStartDate,
        standardEndDate,
        Name: `Vendor Management Report`,
        UserName: userData?.user_name,
        Location: userData?.location || "-",
        Country: userData?.country || "-",
        department: userData?.department || "-",
        header,
        MemoizedImage:Logo
      });
    }else{
      setIsDataLoading(false);
    }

    return () => {
      setIsDataLoading(false);
      worker.terminate();
    }
  }, [data,company,standardDetailName]);

  // Filter Handlers
  const handleFilterSubmit = useCallback((values) => {
    setFilterParams(values);
    setShowFilter(false);
  }, []);

  const handleOnClose = useCallback(() => {
    setShowFilter(false);
    setFilterParams({
      standard_id: stdId,
      module_id: MODULE_ID,
      type: location.state?.reportValue?.reset_count || 0,
      status_name: "",
      from_date: location.state?.reportValue?.start_date || "",
      to_date: location.state?.reportValue?.reset_date || location.state?.reportValue?.end_date || "",
    });
  }, [stdId, location.state]);

  return (
    <>
      <ViewPreDefinedIndex
        label="Vendor Management"
        standardName={standardName}
        menu="Report"
        header={header}
        isLoading={isLoading}
        review={review}
        dataView={data}
        startDate={standardStartDate}
        endDate={standardEndDate}
        pdfUrl={pdfUrl}
        downloadFileName={`${standardName}-Vendor Management Report ${NuDateFormat({
          value: standardStartDate,
          format: "MMM-YYYY",
        })} to ${NuDateFormat({
          value: standardEndDate,
          format: "MMM-YYYY",
        })}.pdf`}
        setShowFilter={() => setShowFilter(true)}
      />
      {showFilter && (
        <FilterModal
          statusValue={statusValue}
          onSubmit={handleFilterSubmit}
          initialValues={filterParams}
          onClose={handleOnClose}
        />
      )}
      <PDFGenerationScreen
        visible={isDataLoading}
        activity={"Vendor Management Report"}
        format={"pdf"}
        name={standardName}
      />
    </>
  );
}

export default VendorManagementReport;


const header = [
  {
    headone: "Sl No.",
    width: "w-[10%]",
    fieldname: "serial_number",
    type: "text",
    pdfWidth:"10%",
    textAlign:"center"
  },
  {
    headone: "Vendor Name",
    width: "w-[30%]",
    fieldname: "vendor_name",
    type: "text",
    pdfWidth:"30%",
    textAlign:"center"
  },
  {
    headone: "Vendor Type",
    width: "w-[20%]",
    fieldname: "vendor_type",
    type: "text",
    pdfWidth:"20%",
    textAlign:"center"
  },
  {
    headone: "Documents Type - NDA, SLA, Contract",
    width: "w-[20%]",
    fieldname: "attachment",
    type: "file",
    pdfWidth:"20%",
    textAlign:"center"
  },
  {
    headone: "OnBoard Date",
    width: "w-[10%]",
    fieldname: "on_board_date",
    type: "date",
    pdfWidth:"10%",
    textAlign:"center"
  },
  {
    headone: "Last Updated by",
    width: "w-[10%]",
    fieldname: "last_modified_name",
    type: "text",
    pdfWidth:"10%",
    textAlign:"center",
    feildnametwo:"created_name",

  },
];